import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import './mobile_header.scss';

const MobileHeader = ({
  buttonStyle,
  children,
  className,
  label,
  noWrap,
  onBack,
  withBackButton,
}) => {
  const history = useHistory();
  const onBackFunc = onBack || history.goBack;

  return (
    <header className={classnames('mobile-header d-lg-none', className)}>
      {withBackButton && (
        <Button color="link" className={classnames('px-0', buttonStyle)} onClick={onBackFunc}>
          <i className="icon-chevron-left" aria-hidden="true" /> {label}
        </Button>
      )}
      {noWrap ? children : <div>{children}</div>}
    </header>
  );
};

MobileHeader.defaultProps = {
  label: 'Back',
  noWrap: false,
};

MobileHeader.propTypes = {
  buttonStyle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  noWrap: PropTypes.bool,
  onBack: PropTypes.func,
  withBackButton: PropTypes.bool,
};

export default MobileHeader;
